import React, {useEffect, useMemo, useState} from 'react';
import {deleteExtraSpaces} from '../../utils/util';
import moment from 'moment';
import CustomInput from '../../common/components/CustomInput/CustomInput';
import Button from '../../common/components/Button/Button';
import actions from '../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {CustomSelect} from '../../common/components/CustomSelect/CustomSelect';
import Loader from '../../common/components/Loader/Loader';
import Cancel from '../../assets/icons/Cancel';
import {toast} from 'react-toastify';
import Table from '../../common/components/ItemTable/v2/Table';
import Chip from '../../common/components/Chip/v2/Chip';
import {random} from 'lodash';
import PersonInfoCard from '../../common/components/PersonInfoCard/PersonInfoCard';
import {validateSearch} from '../../utils/documentsValidation';

// Roles con sede fija: no eligen prestador ni sede, se toman de su usuario
const BRANCH_FIXED_ROLES = ['PROVIDER_USER', 'PROVIDER_USER_QUOTER'];

const FirstStep = (props) => {
    const {
        name,
        title,
        affiliates,
        getAffiliate,
        getAffiliatesState,
        attentionForCreate,
        setAffiliateSelected,
        switchOfUser,
        role,
        getBranches,
        branches,
        getBranchesProviders,
        branchesProviders,
        getBranchesState,
        getBranchesProvidersState,
        salesforceProviderId,
        cleanBranches,
        setAttentionForCreate,
        cleanGetAffiliatesState,
        cleanListConfig,
        userInfo,
        cleanAttentionsSelected,
        cleanProvidersBranches,
        showSidebar,
        setBranchAndProvider,
        onFinish,
        isSimulation,
    } = props;


    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState(affiliates && affiliates[0]?.documentNumber ? affiliates[0]?.documentNumber : '');
    const [firstView, setFirstView] = useState(true);
    const [affiliateHasNoActivePlans, setAffiliateHasNoActivePlans] = useState(false);
    const [searchTag, setSearchTag] = useState('document');
    const [branchesOptions, setBranchesOptions] = useState([]);
    // Se deriva en el render: guardarlas en un ref no re-renderiza al llegar las
    // sedes y el select quedaba vacio y deshabilitado si la sede ya estaba elegida
    const branchesProvidersOptions = useMemo(() => (branchesProviders ?? []).map((branch) => {
        return {value: branch.branchId.toString(), label: branch.fullName};
    }), [branchesProviders]);
    const [provider, setProvider] = useState(attentionForCreate?.salesforceBranchId ?
        branchesProviders.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.salesforceProviderId :
        null);
    const [branch, setBranch] = useState(attentionForCreate?.salesforceBranchId ?? null);


    const affiliatePlansHeaders = [
        {
            id: 'STATUS',
            title: 'Estado',
            att: 'status',
            flex: 1,
            sort: true,
            renderCell: (params) => <Chip text={params.row.status}
                                          status={params.row.status === 'Activo' ? 'success' : 'error'}/>,
        },
        {id: 'CREDENCIAL', title: 'Credencial', att: 'affiliateNumber', sort: true},
        {id: 'PLAN', title: 'Plan', att: 'name', sort: true},
        {id: 'FECHA DE BAJA', title: 'Fecha de baja', att: 'endDate', sort: true},
    ];

    useEffect(() => {
        cleanBranches();
        if (role === 'ADMIN') {
            getBranches();
        } else if (role === 'PROVIDER_ADMIN') {
            setProvider(salesforceProviderId);
        } else if (BRANCH_FIXED_ROLES.includes(role)) {
            setBranch(userInfo.salesforceBranchName);
            setProvider(userInfo.salesforceProviderName);
        }
        switchOfUser('Nueva atencion');
        cleanAttentionsSelected();
        cleanListConfig('allMedicalServicesConfig');
    }, []);

    useEffect(() => {
        setBranchesOptions(branches?.map((branch) => {
            if (branch.providerId === 'a1l2K000005fIfrQAE') {
                branch.fullName = 'Prestador sin sede';
            }
            return {value: branch.providerId.toString(), label: deleteExtraSpaces(branch.fullName)};
        }));
    }, [branches, getBranchesState.success]);

    useEffect(() => {
        branchesProvidersOptions.length > 0 && setBranch(branchesProvidersOptions[0].value);
    }, [branchesProvidersOptions, getBranchesProvidersState.success]);

    useEffect(() => {
        if ((role === 'PROVIDER_ADMIN' || role === 'ADMIN') && provider) {
            getBranchesProviders(provider);
        }
    }, [provider]);
    useEffect(() => {
        if ((role === 'PROVIDER_ADMIN' || role === 'ADMIN') && branch && provider) {
            setAttentionForCreate({salesforceBranchId: branch, salesforceProviderId: provider});
        } else {
            setAttentionForCreate({
                salesforceBranchId: userInfo.salesforceBranchId,
                salesforceProviderId: userInfo.salesforceProviderId,
            });
        }
    }, [branch]);

    moment.locale('es');


    useEffect(() => {
        if (getAffiliatesState.success) {
            handleAffiliates();
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [getAffiliatesState.success]);

    const handleSearch = async () => {
        try {
            setLoading(true);
            await getAffiliate(search, searchTag);
        } catch (e) {
            console.log(e);
        }
    };

    // const validate = () => {
    //     if (role === 'PROVIDER_USER') {
    //         return validateSearch(search, searchTag);
    //     } else {
    //         return validateSearch(search, searchTag) && provider && branch;
    //     }
    // };

    const handleAffiliates = () => {
        if (affiliates === null) {
            return;
        }
        if (affiliates[0].status === 'Baja' && affiliates.length === 1) {
            affiliates[0].plans = affiliates[0].plans.map((plan) => {
                return {
                    ...plan,
                    status: 'Inactivo',
                    id: random(0, 100000),
                    affiliateNumber: affiliates[0].affiliateNumber,
                    endDate: affiliates[0].downDate,
                };
            });
            setAffiliateHasNoActivePlans(true);
            toast.error('El afiliado no tiene planes activos');
            return;
        }
        setAffiliateSelected({
            searchTag: searchTag,
            affiliate: search,
        });
        if (BRANCH_FIXED_ROLES.includes(role)) {
            setBranchAndProvider(branch, provider);
        } else {
            const branchToSet = branchesProvidersOptions.find((branchProvider) => branchProvider.value === branch).label;
            const providerToSet = branchesOptions.find((branch) => branch.value === provider)?.label;
            setBranchAndProvider(branchToSet, providerToSet);
        }
        cleanGetAffiliatesState();
        onFinish();
    };


    const idTypes = [
        {value: 'document', label: 'Documento'},
        {value: 'affiliateNumber', label: 'Credencial'},
    ];


    if (affiliateHasNoActivePlans) {
        return (
            <div className={'v2-step-div w-60'}>
                <PersonInfoCard fullName={affiliates[0].fullName}
                                attributes={[`DNI: ${affiliates[0].documentNumber}`]}/>
                <div style={{height: '400px', width: '100%'}}>
                    <Table attributes={affiliatePlansHeaders} rows={affiliates[0].plans}
                       rowCount={affiliates[0].plans.length} pageSize={affiliates[0].plans.length}/>
                </div>
                <Button onClick={() => setAffiliateHasNoActivePlans(false)} size='medium'
                        disabled={!provider || !search || !branch}>Volver</Button>
            </div>
        );
    }


    return (
        <div className={'v2-step-div w-60'}>
            <div className={'v2-create-attention-title-div'}>
                <h3 className={'h3 v2-c-text-title'}>{isSimulation ? 'Nueva consulta' : 'Nueva atención'}</h3>
                <p className={'body-1 c-text-subtitle'}>Ingrese los datos del afiliado</p>
            </div>
            {loading ? <Loader/> :
                <div className={'v2-create-attention-input-div'}>
                    {role === 'ADMIN' &&
                        <CustomSelect label={'Prestador'} placeholder={'Seleccionar prestador'}
                                      isSearchable={true}
                                      onChange={(value) => setProvider(value)}
                                      value={provider}
                                      options={branchesOptions}
                                      disabled={branchesOptions?.length === 0 || getBranchesState.loading}
                        />}
                    {(role === 'PROVIDER_ADMIN' || role === 'ADMIN') &&
                        <CustomSelect label={'Sede'} placeholder={'Seleccionar sede'}
                                      onChange={(value) => setBranch(value)}
                                      value={branch}
                                      options={branchesProvidersOptions}
                                      disabled={branchesProvidersOptions.length === 0 || getBranchesProvidersState.loading}
                                      isSearchable={true}/>
                    }
                    <CustomSelect label={'Tipo de identificación'}
                                  placeholder={'Seleccionar tipo de identificación'}
                                  onChange={(value) => setSearchTag(value)}
                                  value={searchTag}
                                  options={idTypes}
                                  isSearchable={true}/>
                    <form className={'width-100'} onSubmit={(e) => {
                        e.preventDefault();
                        if (validateSearch(search, searchTag) && provider && branch) {
                            handleSearch();
                        }
                    }}>
                        <CustomInput label={`N° de ${idTypes.find((id) => id.value === searchTag).label.toLowerCase()}`}
                                     placeholder={`N° de ${idTypes.find((id) => id.value === searchTag).label.toLowerCase()}`}
                                     rightSlot={<Cancel width={'10px'} height={'10px'}/>}
                                     rightSlotOnClick={() => setSearch('')}
                                     value={search}
                                     onChange={setSearch}
                                     type={searchTag === 'affiliateNumber' ? 'credential' : 'text'}
                        />
                    </form>
                        <Button onClick={() => handleSearch()} size='medium'
                                disabled={!validateSearch(search, searchTag) || !provider || !branch}>Consultar</Button>
                </div>
            }
            {affiliates === null && (
                <PersonInfoCard fullName={'Afiliado no encontrado'} attributes={[searchTag === 'affiliateNumber' ? 'Intente con número de documento': 'Intente con número de credencial']}/>
            )}
        </div>
    );
};


const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    affiliates: state.home.affiliates,
    attentionForCreate: state.home.attentionForCreate,
    getAffiliatesState: state.home.getAffiliatesState,
    role: state.login.userInfo.role.name,
    userInfo: state.login.userInfo,
    salesforceProviderId: state.login.userInfo.salesforceProviderId,
    branches: state.home.branches,
    branchesProviders: state.home.branchesProviders,
    getBranchesState: state.home.getBranchesState,
    getBranchesProvidersState: state.home.getBranchesProvidersState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    getAffiliate: (document, type) => dispatch(actions.home.getAffiliateRequest(document, type)),
    cleanAffiliates: () => dispatch(actions.home.cleanAffiliates()),
    setAffiliateSelected: (affiliate) => dispatch(actions.home.setAffiliateSelected(affiliate)),
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
    getBranchesProviders: (id) => dispatch(actions.home.getBranchesProvidersRequest(id)),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    setAttentionForCreate: (attention) => dispatch(actions.home.setAttentionForCreate(attention)),
    cleanGetAffiliatesState: () => dispatch(actions.home.cleanGetAffiliatesState()),
    cleanListConfig: (list) => dispatch(actions.home.cleanListConfig(list)),
    cleanAttentionsSelected: () => dispatch(actions.home.cleanAttentionsSelected()),
    setBranchAndProvider: (branch, provider) => dispatch(actions.home.setBranchAndProvider(branch, provider)),
});

FirstStep.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    affiliates: PropTypes.object,
    getAffiliatesState: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(FirstStep);
